
import React, { useEffect, useRef, useState } from "react";
import { connect } from 'react-redux'
import { Translate } from '../../language'
import { urlServer } from '../../config/GlobalConstant'
import { getConversationsList, getConversation, addMessage, deleteConversation } from "../../actions/messagesActions";
import { getUsers } from "../../actions/getDataActions";
import circle from '../../img/circulogris.png';
import socketLogic from '../../sockets/sockets';
import inMemoryJWT from '../../auth/inMemoryJwt';
import { getProfessionalUsers } from '../../actions/contactsActions'
import InputSearch from "../../utils/components/InputSearch/InputSearch";
import { searchAction } from "../../actions/searchActions";
import ImageNameDescription from "../../utils/components/ImageNameDescription/ImageNameDescription";
import moment from "moment";
import ChatCardMessage from "../../containers/Chat/Message/ChatCardMessage";
import ChatInput from "../../containers/Chat/ChatInput";
import localStorage from "../../utils/hooks/useLocalStorage";

const MessagesAdmin = ({ isLoadingSearchList,
    searchList, searchAction, history, getConversationsList, conversationsList, location, addMessage, getProfessionalUsers, getUsers, professionalList, isLoadingProfessional, isLoadingConversationsList, isLoading, idCurrentChat, getConversation, isLoadingConversation, conversation }) => {

    const [idUserChat, setIdUserChat] = useState(null)
    const scroolRef = useRef(null);
    const scroolToBottom = () => {

        if (scroolRef.current) {
            const scrollHeight = scroolRef.current.scrollHeight;
            const height = scroolRef.current.clientHeight;
            const maxScrollTop = scrollHeight - height;
            scroolRef.current.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
        }

    }
    useEffect(() => {
        scroolToBottom()
    }, []);
    useEffect(() => {
        scroolToBottom()
    }, [idUserChat,,conversation[idUserChat], conversation[idUserChat]?.length]);
    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }
        inMemoryJWT.waitForTokenRefresh().then(() => {
            history.location.pathname.includes('Professional') ?
                getProfessionalUsers() : getUsers()
            getConversationsList(history.location.pathname.includes('Professional') ? true : false);

            if (location.state && location.state.dataUser) {
                setIdUserChat(location.state.dataUser._id)
                setUserChat(location.state.dataUser)
                getConversation(location.state.dataUser, history.location.pathname.includes('Professional') ? true : false)
                //  scroolToBottom()
            }
            else if (idCurrentChat) {
                getConversation(idCurrentChat, history.location.pathname.includes('Professional') ? true : false)
                //scroolToBottom()
                setUserChat(idCurrentChat)
                setIdUserChat(idCurrentChat._id)
            }
        })
        socketLogic.listenAllEvents('private-message', res => {
            console.log();
            addMessage(res, false, true);
            // scroolToBottom()
            // setLastMensaje(prevState => { return { ...prevState, [res.from._id]: { message: {...res.bodyMessage.content,infoSender:res.from}, read: false, count: 1 } } })
            //  setAllMessage(prevState => [...prevState, { _id: res.from._id,  message: {...res.bodyMessage.content,infoSender:res.from} } ])
        })
        if (location.state && location.state.dataStory) {
            setDataResponsStory(location.state.dataStory)
        }
        history.replace()
        return () => {

        }
    }, [])
    useEffect(() => {

        return () => {

            setReplyMenssage(null)
            if (location.state && location.state.dataUser) {
                //  history.replace()   
            } else {
                setDataResponsStory(null)
            }
        }
    }, [idUserChat])


    const idUser = history.location.pathname.includes('Professional') ? localStorage().getItem('professionalID') : localStorage().getItem('idUser')
    const isProfessional = history.location.pathname.includes('Professional') ? true : false

    const [replyMenssage, setReplyMenssage] = useState(null)
    const [searchName] = useState("")
    const [lastMensaje, setLastMensaje] = useState({})
    const [userChat, setUserChat] = useState(null)
    const [isLinkGifOrStiker, ] = useState(false)
    const [linkGifOrStiker, ] = useState('')
    const [, setAllMessage] = useState([])

    const [dataResponsStory, setDataResponsStory] = useState(null)
    const [dataFiles, ] = useState({})

    const [, setLoading] = useState(false)



    useEffect(() => {
        console.log();
    }, [searchName])

    if (history.location.pathname.includes('Professional'))
        var users = !isLoadingProfessional && professionalList.filter(
            (item) => item.name &&
                item.name.toUpperCase().includes(searchName.toUpperCase())
        ) || []
    else
        var users = []
    /* var users = !isLoading && usersList.data.filter(
        (item) => item.name &&
            item.name.toUpperCase().includes(searchName.toUpperCase())
    ) || [] */



    // console.log();

    const handleNewUserMessage = async (dataFiles, sendMessage, clear) => {
        setLoading(true);

        const formData = new FormData();
        Object.values(dataFiles).map((dataFile) => {
            formData.append('files', dataFile.file)
        })
        formData.append('content', `${sendMessage}`)
        { replyMenssage && formData.append('responseToMessageId', `${replyMenssage._id}`) }
        //formData.append('senderID', idUser)
        if (dataResponsStory)
            formData.append('storyID', dataResponsStory.id)

        //formData.append('stateMessage', 1)
        formData.append('link', linkGifOrStiker)
        console.log();
        await fetch(`${urlServer}chats/send-message-admin`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            headers: {
                //'Access-Control-Allow-Origin': '*'
                //'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
            },
            body: formData
        })
            .then(response => response.json())
            .then(respJson => {
                setLoading(false);
                // console.log()
                // socketLogic.setSocketId("hola")
                setIdUserChat(respJson.data.addresseeID)
                getConversation({
                    _id:respJson.data.addresseeID
                })
                addMessage(respJson.data, isProfessional, false, replyMenssage, dataResponsStory)
                //   scroolToBottom()
                clear()
            })
            .catch(() => {
                setLoading(false);
                console.log()
            })
        // Now send the message throught the backend API
    }

    return (
        <div className="column">
            <div className="content-left-messages scroll-menu">
                <div className="contacts-for-messages">
                    <div className="text-bold">{'Mensajes'}</div>
                    <div className="">
                        <InputSearch
                            placeholder={Translate('searchPalcheholder', 'es')}
                            classNameContent=""
                            searchData={(value) => searchAction(value)}
                            isLoading={isLoadingSearchList}
                            renderData={searchList.users && searchList.users.map(user =>
                                <ImageNameDescription
                                    key={user._id}
                                    onClick={() => {
                                        setUserChat(user)
                                        setIdUserChat(user._id)
                                    }}
                                    srcImage={user.picture && user.picture.url ? user.picture.url.small : user.picture}
                                    firstName={user.name}
                                    secondName={user.lastname}
                                    description={null}
                                />)}
                        /></div>
                    {!isLoadingConversationsList && searchName.length === 0 && conversationsList.map(({ addresseeData, conversation }, index) => (
                       true && <ImageNameDescription
                            key={index}
                            onClick={() => {//firstFranchiseId
                                setIdUserChat(addresseeData._id)
                                setUserChat({
                                    name: addresseeData.name ? addresseeData.name : addresseeData.socialReason ? addresseeData.socialReason : "",
                                    picture: addresseeData?.picture && addresseeData.picture.url ? addresseeData.picture.url.small : addresseeData.picture
                                })
                                getConversation(addresseeData._id, isProfessional)
                                //  if (user.data._id !== idUserChat) setAllMessage([])
                                // lastMensaje[user.data._id] && setLastMensaje(prevState => { return { ...prevState, [user.data._id]: { message: lastMensaje[user.data._id].message, read: true } } })
                                // changeStyleimageNameDescription()


                            }}
                            srcImage={addresseeData?.picture && addresseeData.picture.url ? addresseeData.picture.url.small : addresseeData.picture}
                            firstName={addresseeData.name ? addresseeData.name : addresseeData.socialReason ? addresseeData.socialReason : ""}
                            secondName={""}
                            description={ (conversation.lastMessage.senderID!==localStorage().getItem("idProfile") ? "":"» ") + conversation.lastMessage.content }
                        />

                    ))}

                    {(!isLoadingProfessional || !isLoading) && searchName.length > 0 && users.map((user) => (
                        user._id !== idUser && <div
                            onClick={() => {
                                setIdUserChat(user._id)
                                setUserChat(user)
                                getConversation(user, isProfessional)
                                if (user._id !== idUserChat) setAllMessage([])
                                lastMensaje[user._id] && setLastMensaje(prevState => { return { ...prevState, [user._id]: { message: lastMensaje[user._id].message, read: true } } })
                            }}
                            className="column centerItems text-gray relative pointer"
                            key={user._id}>
                            {user.profilePicture ? <img alt="img" onError={(e) => e.target.src = circle} className="picture-search-bar m-1" src={user.profilePicture}></img> :
                                <img alt="img" className="picture-search-bar m-1" src={circle}></img>
                            }
                            {/* <img alt="img" className="pointer img-irn-rankin" src={diammond}></img> */}
                            <div className="row">
                                <div className="">{user.name}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="container-right-messages">
                <div className="column">
                    <div className="container-rooms-chats">
                        <div className="navbar-room-info">
                            {userChat &&
                                <>
                                    <ImageNameDescription
                                        srcImage={userChat.picture && userChat.picture.url ? userChat.picture.url.small : userChat.picture}
                                        firstName={userChat.name}
                                        secondName={userChat.lastname}
                                        shouldDscriptionEllipsis={false}
                                        description={!userChat.connectionStatus ? moment(userChat.lastConnection).fromNow() : "Online"}
                                    />
                                    {/*   <div onClick={() => { deleteConversation(idUserChat) }}>Borrar</div> */}
                                </>

                            }

                        </div>
                        <div ref={scroolRef} className={`content-message-conversation scroll-menu ${(Object.values(dataFiles).length > 0 || isLinkGifOrStiker || dataResponsStory) && 'content-message-conversation-img'}`}>
                            {
                                !idUserChat && (
                                    <div>
                                        Habla con un EcoAdministrador
                                    </div>
                                )
                            }
                            {isLoadingConversation[idUserChat] !== undefined && !isLoadingConversation[idUserChat] && idUserChat && conversation[idUserChat] && conversation[idUserChat].map((message,index) => {
                                 return <ChatCardMessage key={index}
                                 isSelf={ 

                                     message.senderID === localStorage().getItem('idProfile')
                                 }
                                 message={message}
                                 idUser={idUser}
                                 replyMenssage={replyMenssage}
                                 setReplyMenssage={setReplyMenssage}

                                 srcImage={
                                    message.senderUserId ? (message.senderUserId.picture && message.senderUserId.picture.url ? message.senderUserId.picture.url.small : message.senderUserId.picture)
                                        : message.senderFranchiseId ? (message.senderFranchiseId && message.senderFranchiseId.picture && message.senderFranchiseId.picture.url ? message.senderFranchiseId.picture.url.small : message.senderFranchiseId.picture)
                                            : message.senderRepresentativeId ? (message.senderRepresentativeId.userID.picture
                                                && message.senderRepresentativeId.userID.picture.url ? message.senderRepresentativeId.userID.picture.url.small : message.senderRepresentativeId.userID.picture)
                                                : message.senderAdminId ?
                                                    (message.senderAdminId.picture.files.url.origin) :  message.senderWarehouseId ? 
                                                    
                                                    (message.senderWarehouseId.profileId.picture
                                                        && message.senderWarehouseId.profileId.picture.url ? message.senderWarehouseId.profileId.picture.url.small : message.senderWarehouseId.profileId.picture)
                                                    : ''



                                } />
                            })}

                        </div>


                        <ChatInput replyMenssage={replyMenssage} setReplyMenssage={setReplyMenssage} handleNewUserMessage={handleNewUserMessage} />

                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        conversationsList: state.messages.conversationsList,
        isLoadingConversationsList: state.messages.isLoadingConversationsList,
        conversation: state.messages.conversation,
        isLoadingConversation: state.messages.isLoadingConversation,
        idCurrentChat: state.messages.idCurrentChat,
        usersList: state.users.usersList,
        dataReload: state.messages.dataReload,
        isLoading: state.users.isLoadingUsers,
        professionalList: state.contacts.professionalList,
        isLoadingProfessional: state.contacts.isLoadingProfessionalList,
        isLoadingSearchList: state.users.isLoadingSearchList,
        searchList: state.users.searchList,

    };
};

export default connect(mapStateToProps, { searchAction, getConversationsList, getConversation, deleteConversation, getProfessionalUsers, addMessage, getUsers })(MessagesAdmin)